import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import { CertificateCard } from "../models/certificate-card.model";

@Component({
    selector: "certificate-card-face-back",
    templateUrl: "./certificate-card-face-back.component.html",
    styleUrls: ["./certificate-card-face-back.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CertificateCardFaceBackComponent {
    @Input()
    public card: CertificateCard;

    public get name(): string {
        return `${this.card.firstName} ${this.card.lastName}`;
    }

    public openUserPermissionPage(event: MouseEvent): void {
        event.stopPropagation();
        window.open(this.card.qrCodeUrl, "_blank");
    }
}
